export default __webpack_public_path__ + "static/Cart-Gear-6845b335f60f348995e220678612280f.webp";